// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgLocationIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="M11.25 22.95v-1.875q-3.424-.35-5.7-2.625-2.275-2.276-2.625-5.7H1.05v-1.5h1.875q.35-3.424 2.625-5.7 2.276-2.275 5.7-2.625V1.05h1.5v1.875q3.425.35 5.7 2.625t2.625 5.7h1.875v1.5h-1.875q-.35 3.425-2.625 5.7t-5.7 2.625v1.875zM12 19.6q3.124 0 5.363-2.238Q19.6 15.126 19.6 12t-2.238-5.362Q15.126 4.4 12 4.4T6.638 6.638Q4.4 8.875 4.4 12t2.238 5.363T12 19.6m0-3.85q-1.575 0-2.662-1.088Q8.25 13.576 8.25 12t1.088-2.662Q10.425 8.25 12 8.25q1.576 0 2.662 1.088Q15.75 10.425 15.75 12q0 1.576-1.088 2.662Q13.576 15.75 12 15.75m0-1.5q.95 0 1.6-.65t.65-1.6-.65-1.6-1.6-.65-1.6.65-.65 1.6.65 1.6 1.6.65" />
  </Icon>
);
export default SvgLocationIcon;
SvgLocationIcon.displayName = 'SvgLocationIcon';
